var React = require('react');

function SmallArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.986328 1.9364L9.0002 9.95028L17.0141 1.9364L15.1285 0.0507822L9.0002 6.17904L2.87195 0.0507813L0.986328 1.9364Z"}));
}

SmallArrowDown.defaultProps = {"width":"18","height":"10","viewBox":"0 0 18 10","fill":"true"};

module.exports = SmallArrowDown;

SmallArrowDown.default = SmallArrowDown;
